import $okgportal_api from "@/shared/client/okgportal.client";
import { BaseOkgportalResponce, DepartmentInterface } from "@/shared/model/api.types";

class DepartmentApi{
  async getAll(){
    try {
      const response = await $okgportal_api.get<BaseOkgportalResponce<DepartmentInterface[]>>('/department/all');
      return response.data
    } catch (error) {
      throw error
    }
  }
}

const departmentApi = new DepartmentApi();
export default departmentApi;